import type { PullRequestState } from "@/lib/pr-status-cache"

export const SESSION_PR_STATUS_UPDATED_EVENT = "cord:session-pr-status-updated"
export const SESSION_QUICK_PR_COMPLETED_EVENT = "cord:session-quick-pr-completed"

export interface SessionPrStatusUpdatedDetail {
  sessionId: string
  prNumber: number
  prUrl: string | null
  prState: PullRequestState
  headBranch?: string | null
  baseBranch?: string | null
  mergeable?: boolean | null
  mergeableState?: string | null
  mergeabilityKnown?: boolean
  timestamp?: number | null
}

export interface SessionQuickPrCompletedDetail {
  sessionId: string
}

export function dispatchSessionPrStatusUpdated(
  detail: SessionPrStatusUpdatedDetail,
): void {
  if (typeof window === "undefined") return
  window.dispatchEvent(
    new CustomEvent<SessionPrStatusUpdatedDetail>(SESSION_PR_STATUS_UPDATED_EVENT, {
      detail,
    }),
  )
}

export function dispatchSessionQuickPrCompleted(
  detail: SessionQuickPrCompletedDetail,
): void {
  if (typeof window === "undefined") return
  window.dispatchEvent(
    new CustomEvent<SessionQuickPrCompletedDetail>(SESSION_QUICK_PR_COMPLETED_EVENT, {
      detail,
    }),
  )
}
